import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import {
  ActionButtons,
  actionPanelHeight
} from 'src/screens/progression-report/ActionButtons'
import {
  DetailsSection,
  DetailsWithLoading
} from 'src/screens/progression-report/Details'

export interface HeaderProps {
  isLoading: boolean
  hasError: boolean
  hasProgressions: boolean
  isPublic?: boolean
  isOwner?: boolean
}

export function ProfileHeader(props: HeaderProps) {
  const { description, title } = useProfileText(props)

  return (
    <Header
      {...props}
      section={DetailsSection.profile}
      title={title}
      finalDescription={description}
    />
  )
}

function useProfileText(props: HeaderProps) {
  const { t } = useTranslation()
  const namespace = 'overview:profile:details'

  if (!props.hasProgressions) {
    return {
      title: t(`${namespace}:need_more_matches_title`),
      description: t(`${namespace}:need_more_matches_description`)
    }
  }

  if (!props.isOwner) {
    return {
      title: t(`${namespace}:non_owner_title`),
      description: t(`${namespace}:non_owner_description`)
    }
  }

  const title = t(`${namespace}:title`)

  const description = t(`${namespace}:description`)

  return {
    title,
    description
  }
}

export function MatchesHeader(props: HeaderProps) {
  const { t } = useTranslation()
  const namespace = 'overview:matches:details'
  const title =
    props.isLoading || props.hasProgressions
      ? t(`${namespace}:title`)
      : t(`${namespace}:need_more_matches_title`)

  const finalDescription = t(`${namespace}:description`)

  return (
    <Header
      {...props}
      section={DetailsSection.matches}
      title={title}
      finalDescription={finalDescription}
    />
  )
}

function Header(
  props: {
    title: string
    finalDescription: string
    section: DetailsSection
  } & HeaderProps
) {
  return (
    <Box>
      <StyledDetails {...props} />
      <StyledActionButtons />
    </Box>
  )
}

const Box = styled.div`
  margin-bottom: ${(props) => props.theme.d.spacing[5]};
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${(props) => props.theme.d.breakpoints.md}) {
    flex-wrap: nowrap;
    height: ${actionPanelHeight}px;
  }
`

const StyledDetails = styled(DetailsWithLoading)`
  flex: 100%;
  margin-bottom: ${(props) => props.theme.d.spacing[5]};

  @media (min-width: ${(props) => props.theme.d.breakpoints.md}) {
    margin-right: ${(props) => props.theme.d.spacing[5]};
    margin-bottom: 0;
    height: 100%;
    flex: 1;
  }
`

const StyledActionButtons = styled(ActionButtons)`
  flex: 100%;

  @media (min-width: ${(props) => props.theme.d.breakpoints.md}) {
    flex: 1;
  }

  @media (min-width: ${(props) => props.theme.d.breakpoints.md}) {
    flex: 0 0 406px;
  }
`
